<template>
  <div class="space-y-12 p-16">
    <div class="flex items-center justify-between">
      <slot name="header" />

      <RevTag
        v-if="savingsAmount"
        :label="i18n(translations.savingsLabel, { amount: savingsAmount })"
        size="large"
        variant="primary"
      />
    </div>

    <div class="space-y-12">
      <div class="space-y-2 body-1">
        <div>{{ phoneLabel }}</div>
        <div>{{ i18n(translations.planPrefix, { planCost }) }}</div>
      </div>

      <p v-if="discountLabel" class="caption text-static-success-hi">
        {{ discountLabel }}
      </p>

      <p
        class="heading-2 w-full text-right"
        :class="
          isContract ? 'text-static-default-hi' : 'text-static-success-hi'
        "
      >
        {{ totalCost }} {{ i18n(translations.totalSuffix) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import translations from './MobileComparisonRow.translations'

const props = defineProps<{
  phoneCost: string
  planCost: string
  savingsAmount: string
  totalCost: string
  discountLabel?: string
  isContract?: boolean
}>()

const i18n = useI18n()

const phoneLabel = computed(() =>
  props.isContract
    ? i18n(translations.contractPhone, { phoneCost: props.phoneCost })
    : i18n(translations.refurbishedPhone, { phoneCost: props.phoneCost }),
)
</script>
